import React from 'react';
import SEOHead from '@/components/SEOHead';
import HeroSection from '@/components/home/HeroSection';
import StatsSection from '@/components/home/StatsSection';
import ServicesSection from '@/components/home/ServicesSection';
import WorkProcessSection from '@/components/home/WorkProcessSection';
import CertificationsSection from '@/components/home/CertificationsSection';
import FeaturedProjectsSection from '@/components/home/FeaturedProjectsSection';
import DesignShowcaseSection from '@/components/home/DesignShowcaseSection';
import TestimonialsSection from '@/components/home/TestimonialsSection';
import FAQSection from '@/components/home/FAQSection';
import CTASection from '@/components/home/CTASection';
import { useLanguage } from '@/contexts/LanguageContext';

const HomePage: React.FC = () => {
  const { t } = useLanguage();

  const faqData = Array.from({ length: 7 }, (_, i) => ({
    question: t(`home.faq.${i + 1}.q`),
    answer: t(`home.faq.${i + 1}.a`),
  }));

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  };

  return (
    <div className="flex flex-col">
      <SEOHead
        title="Construcción e Inspección de Rocódromos en España"
        description="Expertos en construcción, inspección y certificación de rocódromos, muros de escalada y parques de aventura en España con más de 15 años de experiencia."
        path="/"
        jsonLd={faqJsonLd}
      />
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      <WorkProcessSection />
      <CertificationsSection />
      <FeaturedProjectsSection />
      <DesignShowcaseSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
